export var CreditorState;
(function (CreditorState) {
    CreditorState["Lead"] = "LEAD";
    CreditorState["SignedOn"] = "SIGNED_ON";
    CreditorState["Active"] = "ACTIVE";
    CreditorState["Cancelled"] = "CANCELLED";
    CreditorState["Ceased"] = "CEASED";
})(CreditorState || (CreditorState = {}));
//# sourceMappingURL=index.js.map